import React from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import './index.css';

function SwiperCard(
    {
        lista,
        index
    }
) {
    const params = {
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true
        }
    }

    return (
        <Swiper initialSlide={index}
            watchOverflow={true}
            {...params}>
            {lista}
        </Swiper>
    );
}

export default SwiperCard;